import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`,
          "name": "JLD Concept SRL",
          "url": import.meta.env.VITE_SITE_URL,
          "logo": `${import.meta.env.VITE_SITE_URL}/vite.svg`,
          "description": "JLD Concept, votre partenaire télécom et énergie en Belgique. Solutions Orange Belgique et énergie verte Eneco.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Rue de l'Abbaye 5",
            "addressLocality": "Herstal",
            "postalCode": "4040",
            "addressCountry": "BE"
          },
          "telephone": "+32498664215",
          "email": "jld@danko.be",
          "areaServed": "BE",
          "sameAs": []
        },
        {
          "@type": "WebSite",
          "@id": `${import.meta.env.VITE_SITE_URL}/#website`,
          "url": import.meta.env.VITE_SITE_URL,
          "name": "JLD Concept",
          "description": "Solutions télécom Orange Belgique et énergie verte Eneco pour entreprises et particuliers en Belgique.",
          "publisher": { "@id": `${import.meta.env.VITE_SITE_URL}/#organization` },
          "inLanguage": "fr-BE"
        },
        {
          "@type": "LocalBusiness",
          "@id": `${import.meta.env.VITE_SITE_URL}/#localbusiness`,
          "name": "JLD Concept SRL",
          "url": import.meta.env.VITE_SITE_URL,
          "telephone": "+32498664215",
          "email": "jld@danko.be",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Rue de l'Abbaye 5",
            "addressLocality": "Herstal",
            "postalCode": "4040",
            "addressCountry": "BE"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 50.67,
            "longitude": 5.60
          },
          "priceRange": "€€",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
              "opens": "09:00",
              "closes": "18:00"
            }
          ]
        }
      ]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { document.getElementById('schema-home')?.remove(); };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/c3f226f03ca5027a34293e25bdb3e2d2.jpg)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            VOTRE PARTENAIRE<br />TÉLÉCOM &amp; ÉNERGIE<br />EN BELGIQUE
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto font-light">
            Solutions professionnelles en collaboration avec Orange Belgique et Eneco
          </p>
          <Link
            to="/services"
            className="inline-block px-8 py-4 bg-green-500/80 hover:bg-green-600 text-white font-semibold rounded-full transition-all text-lg whitespace-nowrap"
          >
            Découvrir nos services
          </Link>
        </div>

        <div className="absolute bottom-12 left-0 right-0 text-center">
          <div className="text-white text-2xl md:text-4xl font-extrabold tracking-widest">
            INNOVATION • FIABILITÉ • EXPERTISE
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Économisez sur vos services quotidiens
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Nous vous aidons à épargner sur des services que vous utilisez tous les jours. 
              Nous vous garantissons des services d'excellente qualité grâce à la collaboration 
              avec des partenaires fiables, comme Orange et Eneco.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                <i className="ri-money-euro-circle-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Save Money!</h3>
              <p className="text-gray-600 leading-relaxed">
                Réduisez vos factures mensuelles grâce à nos offres compétitives en télécom et énergie. 
                Des économies garanties sans compromis sur la qualité.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-xl mb-6">
                <i className="ri-hand-coin-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Make Money!</h3>
              <p className="text-gray-600 leading-relaxed">
                Devenez consultant et générez des revenus supplémentaires. Plus de 230.000 belges 
                ont déjà un second job. Rejoignez-nous!
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-orange-600 to-orange-500 rounded-2xl p-12 text-white text-center">
            <h3 className="text-3xl font-bold mb-6">Construisez votre avenir</h3>
            <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
              Nous vous aidons à améliorer, à votre rythme, votre qualité de vie. Plus de temps avec 
              votre famille, une belle voiture, un beau voyage… Chez nous, vous vous construisez un 
              avenir qui vous permette de passer plus de temps pour les choses vraiment importantes.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="text-center">
                <i className="ri-store-2-line text-4xl mb-2"></i>
                <p className="text-sm font-medium">Pas de stock</p>
              </div>
              <div className="text-center">
                <i className="ri-team-line text-4xl mb-2"></i>
                <p className="text-sm font-medium">Pas d'employés</p>
              </div>
              <div className="text-center">
                <i className="ri-file-list-line text-4xl mb-2"></i>
                <p className="text-sm font-medium">Pas de lourdeur administrative</p>
              </div>
              <div className="text-center">
                <i className="ri-rocket-line text-4xl mb-2"></i>
                <p className="text-sm font-medium">Commencer sans risque</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-20 bg-gradient-to-br from-orange-50 to-green-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block text-sm font-semibold text-orange-600 bg-orange-100 px-4 py-2 rounded-full mb-4">
              NOS PARTENAIRES
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Des partenaires de confiance
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-black rounded-2xl p-8 text-white hover:scale-105 transition-transform">
              <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mb-6">
                <img
                  src="https://static.readdy.ai/image/9c58d8b9dc921ceebc49b67abc2b926b/a44856ff065b1800f24e74458addede3.png"
                  alt="Orange Belgique"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <h3 className="text-2xl font-bold mb-4">TÉLÉCOM PROFESSIONNEL</h3>
              <p className="text-gray-300 text-sm">
                Solutions mobiles et fixes pour entreprises avec Orange Belgique
              </p>
            </div>

            <div className="relative rounded-2xl overflow-hidden hover:scale-105 transition-transform">
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: 'url(https://readdy.ai/api/search-image?query=Green%20renewable%20energy%20installation%20with%20solar%20panels%20and%20wind%20turbines%20in%20natural%20landscape%2C%20sustainable%20power%20generation%20facilities%2C%20bright%20sunny%20day%20with%20blue%20sky%20and%20green%20fields&width=600&height=800&seq=eneco001&orientation=portrait)',
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20"></div>
              </div>
              <div className="relative p-8 h-full flex flex-col justify-between min-h-[400px]">
                <div className="self-start">
                  <img
                    src="https://static.readdy.ai/image/9c58d8b9dc921ceebc49b67abc2b926b/e670cdcaf1ecd738ddf0cd16b324bd0d.png"
                    alt="Eneco"
                    className="w-36 h-20 object-contain"
                  />
                </div>
                <h3 className="text-3xl font-bold text-white">SOLUTIONS DURABLES</h3>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:scale-105 transition-transform">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">RÉSEAU D'EXCELLENCE</h3>
              <p className="text-gray-600 mb-6 text-sm">
                Smart Services Network, filiale du groupe Orange depuis 2014
              </p>
              <div
                className="w-full h-48 bg-cover bg-center rounded-xl"
                style={{
                  backgroundImage: 'url(https://readdy.ai/api/search-image?query=Professional%20business%20network%20consultants%20team%20meeting%20in%20modern%20office%2C%20diverse%20group%20collaboration%20around%20table%2C%20bright%20natural%20lighting%20and%20contemporary%20workspace%20design&width=600&height=400&seq=network001&orientation=landscape)',
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Professional%20business%20team%20in%20modern%20bright%20office%20environment%2C%20diverse%20colleagues%20working%20together%20with%20natural%20warm%20lighting%2C%20contemporary%20workspace%20with%20large%20windows%20and%20natural%20light&width=1920&height=1080&seq=cta001&orientation=landscape)',
          }}
        >
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        <div className="relative z-10 text-center px-6">
          <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-6 tracking-wide">
            DEVENEZ CONSULTANT
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-10 font-light max-w-2xl mx-auto">
            Liberté, amusement et accompagnement professionnel
          </p>
          <Link
            to="/devenir-consultant"
            className="inline-flex items-center space-x-4 bg-black text-white px-8 py-4 rounded-full hover:bg-gray-900 transition-all whitespace-nowrap"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-orange-600 rounded-full">
              <i className="ri-briefcase-line text-white text-lg"></i>
            </div>
            <span className="font-semibold text-lg">REJOIGNEZ-NOUS</span>
            <i className="ri-arrow-right-up-line text-xl"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}